import { render } from "./tcf-message.vue?vue&type=template&id=b3ba3b2e&scoped=true"
const script = {}

import "./tcf-message.vue?vue&type=style&index=0&id=b3ba3b2e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ba3b2e"]])

export default __exports__